"use strict";

ixModuleRouting("impactx.budget", {
    "/budgetlist": {
        template: "<ixa-budget-list></ixa-budget-list>",
        templateUrl: "modules/budget/templates/budgetlist.html",
        process: "ListBudget",
        controller: "BudgetListCtrl",
        controllerAs: "budgetListCtrl",
    },
    "/budget/:id": {
        template: "<ixa-budget-detail></ixa-budget-detail>",
        templateUrl: "modules/budget/templates/budget.html",
        process: "EditBudget",
        controller: "BudgetDetailCtrl",
        controllerAs: "budgetCtrl",
    },
    "/budgettemplatelist": {
        template: "<ixa-budget-template-list></ixa-budget-template-list>",
        templateUrl: "modules/budget/templates/btplist.html",
        process: "ListBudgetTemplate",
        controller: "BudgetTemplateListCtrl",
        controllerAs: "budgetTemplateListCtrl",
    },
    "/budgettemplateusagelist/:id": {
        template: "<ixa-budget-template-ussage-list></ixa-budget-template-ussage-list>",
        templateUrl: "modules/budget/templates/btpusagelist.html",
        process: "ListBudgetTemplate",
        controller: "BudgetTemplateUsageListCtrl",
        controllerAs: "budgetTemplateUsageListCtrl",
    },
    "/budgettemplate/:id": {
        template: "<ixa-budget-template-dialog></ixa-budget-template-dialog>",
        templateUrl: "modules/budget/templates/btp.html",
        process: "EditBudgetTemplate",
        controller: "BudgetTemplateCtrl",
        controllerAs: "budgetTemplateCtrl",
    },
    "/budgetown": {
        template: "<ixa-budgetown></ixa-budgetown>",
        templateUrl: "modules/budget/templates/budgetown.tmpl.html",
        process: "BudgetOwn",
        controller: "BudgetOwnCtrl",
        controllerAs: "BudgetOwnCtrl",
    },
});
